export const OnboardingLivesScreenPath = "/onboarding-lives";
export const OnboardingLiveDetailScreenPath =
  "/onboarding-lives/:onboardingLiveId";
export const OnboardingLivePlanScreenPath = "/onboarding-lives/plans/:intentId";

export function onboardingLiveDetailPathOf(onboardingLiveId: string): string {
  return OnboardingLiveDetailScreenPath.replace(
    ":onboardingLiveId",
    onboardingLiveId,
  );
}

export function onboardingLivePlanPathOf(intentId: string): string {
  return OnboardingLivePlanScreenPath.replace(":intentId", intentId);
}
